import { createSelector } from '@ngrx/store'

export const getDashboardsState = createSelector(
  (state: any) => state.mapAnalytics,
  (state: any) => state.get('dashboards'),
)

export const getDashboardDataState = createSelector(
  (state: any) => state.mapAnalytics,
  (state: any) => state.get('dashboardData'),
)
